<template>
  <vs-popup class="create-wizard-pop-up" id="popup" fullscreen
    :title="`${is_on_create ? 'Create' : 'Update'} ${object_data.label}`" @close="onClickClosePopup" :active.sync="open"
    :buttons-hidden="true">

    <vx-card no-shadow v-if="is_wizard_visible">

      <div v-if="is_on_create" class="hidden">
        <vx-card noShadow>
                <div class="border-2 border-dashed border-gray-300 rounded-lg p-6 mb-6 text-center hover:border-primary cursor-pointer transition-colors duration-300"
                    @click="triggerFileInput" @dragover.prevent="dragover = true" @dragleave.prevent="dragover = false"
                    @drop.prevent="onFileDrop" :class="{ 'bg-primary-lighter border-primary': dragover }">
                    <input ref="fileInput" type="file" class="hidden" @change="onUploadFile" />
                    <i class="text-4xl text-gray-400 mb-2 fas fa-cloud-upload-alt"></i>
                    <p class="text-gray-600 mb-1">Drag and drop exisiting document here or click to browse</p>
                    <p class="text-xs text-gray-500">Supported file types: PDF.</p>
                </div>

            </vx-card>
      </div>

      <form-wizard ref="formWizards" :title="object_data.label" :subtitle="object_data.description"
        :startIndex="startIndex" color="#2E315D" shape="tab" finishButtonText="Submit"
        @on-complete="onClickCreateWizard" stepSize="xs" transition="bounce">

        <tab-content :title="screen.name" v-for="(screen, index) in object_data.screens" :key="index" :before-change="validateSteps">
          <div class="flex mb-3">
            <vs-button v-if="index !== 0" class="float-left ml-0 mr-auto" @click="onClickBack()">Back</vs-button>
            <vs-button v-if="!is_on_create" icon-pack="feather" icon="icon-save" type="border" class="float-right ml-auto mr-3" @click="onClickCreateWizard()">Save</vs-button>
            <vs-button icon-pack="feather" icon="icon-save" type="border" class="float-right mr-2" :class="is_on_create ? 'ml-auto' : ''" @click="onClickCreateWizard(true)">Save & Close</vs-button>
            <vs-button icon-pack="feather" icon="icon-skip-forward" class="float-right mr-0" @click="onClickNext()">Save & Next</vs-button>
          </div>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form autocomplete="off">
              <vx-card v-for="(section, index) in screen.sections" :key="index" class="mb-3" :title="section.name"
                cardBorder noShadow>

                <div class="vx-row mb-3">
                  <template v-for="(field, index) in section.fields">
                    <div class="vx-col w-full mb-3" v-if="isFieldVisible(field)"
                      :class="{ 'md:w-1/2': !['textarea', 'dynamic_form'].includes(field.type) }">
                      <ValidationProvider :vid="field.name" :name="field.name" :rules="field.required ? 'required' : ''"
                        v-slot="{ errors }">
                        <small class="label">{{ field.label }}</small> <small class="text-danger ml-4"
                          v-if="field.required && !form[field.name]">*This field is required</small>

                        <span v-if="field.type === 'text'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" />
                        </span>

                        <span v-if="field.type === 'dropdown'">
                          <v-select class="style-chooser" :disabled="field.isDisabled || field.isReadOnly" :clearable="true"
                            v-model="form[field.name]" :reduce="option => option" :options="field.options.static">
                          </v-select>
                        </span>

                        <span v-if="field.type === 'multiselect'">
                          <v-select :disabled="field.isDisabled || field.isReadOnly" :clearable="true" v-model="form[field.name]"
                            :reduce="option => option" :options="field.options.static" multiple>
                          </v-select>
                        </span>

                        <span v-if="field.type === 'phone'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" />
                        </span>

                        <span v-if="field.type === 'url'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" />
                        </span>

                        <span v-if="field.type === 'currency'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" />
                        </span>

                        <span v-if="field.type === 'number'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" type="number"/>
                        </span>

                        <span v-if="field.type === 'email'">
                          <vs-input :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" />
                        </span>

                        <span v-if="field.type === 'textarea'">
                          <vs-textarea :disabled="field.isDisabled || field.isReadOnly" v-model="form[field.name]" :name="field.name"
                            class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                            val-icon-danger="icon-x" val-icon-pack="feather" 
                            :height="getTextareaHeight(field.name)" @mouseup="captureManualResize(field.name)" :ref="`ta-${field.name}`"/>
                        </span>

                        <span v-if="field.type === 'date'">
                          <flat-pickr class="hidden w-full" v-model="form[field.name]"
                            placeholder="" />
                          <flat-pickr :disabled="field.isDisabled || field.isReadOnly"
                            v-model="form[field.name]" placeholder="" class="w-full" />
                        </span>

                        <span v-if="field.type === 'datetime'">
                          <flat-pickr class="hidden w-full" v-model="form[field.name]"
                            placeholder="" />
                          <flat-pickr :disabled="field.isDisabled || field.isReadOnly"
                            v-model="form[field.name]" placeholder="" class="w-full" />
                        </span>

                        <span v-if="field.type === 'checkbox'">
                          <YesNoToggle v-model="form[field.name]" :disabled="field.isDisabled || field.isReadOnly" />
                        </span>

                        <span v-if="['lookup', 'lookup_multiple'].includes(field.type)">
                          <v-select :disabled="field.isDisabled || field.isReadOnly" :clearable="true" v-model="form[field.name]"
                            :reduce="option => option[field.options.dynamic.valueField]"
                            :options="lookup_options[field.options.dynamic.objectName]"
                            :label="field.options.dynamic.displayField" :multiple="field.type === 'lookup_multiple'">
                          </v-select>
                        </span>

                        <!-- Dynamic form with buttons -->
                        <span v-if="field.type === 'dynamic_form'">

                          <table border="1" class="w-full">
                            <thead>
                              <tr>
                                <th v-for="(additional_field, index_label) in field.additionalProperties.fields"
                                  :key="`header_${additional_field.name}_${index_label}`"
                                  :style="{ width: `${95 / field.additionalProperties.fields.length}%` }">
                                  {{ additional_field.label }}
                                </th>
                                <th style="width: 5%;">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, row_index) in form[field.name]" :key="`row_${row_index}`">
                                <td v-for="(additional_field, column_index) in field.additionalProperties.fields"
                                  :key="`column_${additional_field.name}_${column_index}`"
                                  :style="{ width: `${95 / field.additionalProperties.fields.length}%` }">


                                  <span v-if="additional_field.type === 'text'">
                                    <vs-input @input="onInputDynamicFormField()"
                                      v-model="form[field.name][row_index][additional_field.name]" class="w-full"
                                      label="" />
                                  </span>

                                  <span v-if="additional_field.type === 'textarea'">
                                    <vs-textarea @input="onInputDynamicFormField()"
                                      v-model="form[field.name][row_index][additional_field.name]" class="w-full"
                                      label="" />
                                  </span>

                                  <span v-if="additional_field.type === 'multiselect'">
                                    <v-select @input="onInputDynamicFormField()" :clearable="true"
                                      v-model="form[field.name][row_index][additional_field.name]"
                                      :reduce="option => option" :options="additional_field.options.static" multiple
                                      class="w-full">
                                    </v-select>
                                  </span>
                                </td>
                                <td style="width: 5%;">
                                  <div @click="removeDynamicFormRow(row_index, field.name)"
                                    class="delete_button bg-danger">
                                    Delete
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="add_button mt-3 bg-primary" @click.stop="addDynamicFormRow(field)">Add</div>
                        </span>

                      </ValidationProvider>
                    </div>
                  </template>

                </div>
              </vx-card>
            </form>
          </ValidationObserver>

        </tab-content>
      </form-wizard>




      <!-- <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateWizard)" autocomplete="off">
          
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickReset" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver> -->
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const ObjectRepository = RepositoryFactory.get('object');
const TenantRepository = RepositoryFactory.get('tenant')

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import YesNoToggle from '@/components/shared/YesNoToggle.vue'

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

function initialState() {
  return {
    open: false,
    object_name: '',
    object_data: {
      screens: []
    },
    form: {},
    lookup_options: {},
    is_on_create: true,
    all_fields: [],
    is_wizard_visible: false,
    startIndex: 0,
    dragover: false,
    response: {},
    form_dirty: false,
    textareaHeights: {},
    manualResized: {}
  }
}

export default {
  name: 'CreateWizardObjectPopUp',
  data() {
    return initialState()
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    'v-select': vSelect,
    flatPickr,
    FormWizard,
    TabContent,
    YesNoToggle,
  },

  methods: {
    async openPopup(object_name, method = 'create', form_data = {}) {
      try {
        Object.assign(this.$data, initialState())
        this.object_name = object_name
        this.is_on_create = method === 'create'
        await this.fetchObjectData()
        this.form = form_data
        await this.fetchLookupData()
        if(!this.is_on_create) {
          await this.fetchWizardData(form_data._id)
        }
        await this.checkDynamicForms()

        // let all_fields = this.object_data.screens.flatMap((x) => x.sections.flatMap((y) => y.fields))
        // if (this.is_on_create && Object.keys(form_data).length > 0) {
        //   const disabled_keys = Object.keys(form_data)
        //   all_fields.forEach((field) => {
        //     if (disabled_keys.includes(field.name)) {
        //       field.isDisabled = true
        //     }
        //   })
        // }
      } catch (error) {
        console.log("error", error)
      } finally {
        this.open = true
        this.is_wizard_visible = true
        // this.startIndex = 12
        // this.$refs.formWizards.activateAll()

        setTimeout(() => {
          if (!this.is_on_create) {
            this.$refs.formWizards.activateAll()
          }
        }, 1500)
        this.$forceUpdate()
      }
    },
    async onClickClosePopup() {
      this.open = false
      this.$parent.refreshData()
    },
    async fetchObjectData() {
      this.$vs.loading()
      try {
        const { data } = (await ObjectRepository.getWizardData(this.object_name)).data
        this.object_data = data
        this.all_fields = data.screens.flatMap((x) => x.sections.flatMap((y) => y.fields))
      } catch (e) {
        this.$vs.loading.close()
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchLookupData() {
      try {
        const lookup_fields = this.all_fields
          .filter(field => (field.type === 'lookup' || field.type === 'lookup_multiple') && !field.isHidden)
          .map((x) => x.options.dynamic.objectName)
        const unique_lookup_fields = [...new Set(lookup_fields)]
        if (unique_lookup_fields.length > 0) {
          const lookup_options = await Promise.all(unique_lookup_fields.map(async (objectName) => {
            const { data } = await ObjectRepository.fetchLookupData(objectName, this.form.Company && this.form.Company._id ? `account_id=${this.form.Company._id}` : (this.form.Company ? `account_id=${this.form.Company}` : ''))
            return { [objectName]: data.data.data }
          }))
          this.lookup_options = lookup_options.reduce((acc, x) => ({ ...acc, ...x }), {})
        }
      } catch (error) {
        this.convertAndNotifyError(e)
      }
    },
    async checkDynamicForms() {
      try {
        const dynamic_form_fields = this.all_fields.filter(field => field.type === 'dynamic_form')
        dynamic_form_fields.forEach(field => {
          if (!this.form[field.name]) {
            this.form[field.name] = []
          }
        })
      } catch (error) {
        this.convertAndNotifyError(e)
      }
    },
    addDynamicFormRow(field) {
      const newRow = {}
      field.additionalProperties.fields.forEach(additional_field => {
        newRow[additional_field.name] = ""
      });

      this.form[field.name].push(newRow);
      this.$forceUpdate()
    },
    removeDynamicFormRow(index, field_name) {
      this.form[field_name].splice(index, 1);
      this.$forceUpdate()
    },
    onInputDynamicFormField() {
      this.$forceUpdate()
    },
    async onClickCreateWizard(should_close = false) {
      this.$vs.loading()
      try {
        if (this.is_on_create) {
          await ObjectRepository.createWizard(this.object_name, this.form)
        } else {
          await ObjectRepository.updateWizard(this.object_name, this.form._id, this.form)
        }
        this.$parent.refreshData()
      } catch (error) {

      } finally {
        this.$vs.loading.close()
        console.log({should_close})
        if(should_close || this.is_on_create) {
          console.log('closing');
          this.open = false
        }
      }
    },
    async fetchWizardData(id) {
      try {
        const { data } = (await ObjectRepository.getWizard(this.object_name, id)).data
        this.form = data.data
      } catch (error) {
        
      }
    },
    onClickReset() {
      this.form = {}
    },
    async validateSteps() {
      let active_index = this.$refs.formWizards.activeTabIndex
      return new Promise(async(resolve, reject) => {
        const fields = this.object_data.screens[active_index].sections.flatMap(section => section.fields).filter(field => field.required)
        let validation_count = 0
        fields.forEach(field => {
          if (this.form[field.name] !== undefined && this.form[field.name] !== null && this.form[field.name] !== '') {
            validation_count++
          }
        })
        if (validation_count === fields.length) {
          await this.handleNextTab()
          resolve(true)
        } else {
          this.$vs.notify({
            title: 'Validation Error',
            text: 'Please fill all required fields before proceeding.',
            color: 'danger',
            position: 'top-right'
          });
          reject("correct all values");
        }
      })
    },
    async handleNextTab() {
      if(this.is_on_create) {
        const { data } =  (await ObjectRepository.createWizard(this.object_name, this.form)).data
        this.form._id = data.data._id
        this.is_on_create = false
        this.form_dirty = false
      } else if(this.form_dirty) {
        await ObjectRepository.updateWizard(this.object_name, this.form._id, this.form)
        this.form_dirty = false
      }
      this.form_dirty = false
    },
    async onClickNext() {
      this.$refs.formWizards.nextTab()
    },
    onClickBack() {
      this.$refs.formWizards.prevTab()
    },
    isFieldVisible(field) {
      if(field.isHidden) {
        return false
      }
      if (!field.visibilityCondition) {
        return true; // No condition, always visible
      }

      const { logic = "AND", rules } = field.visibilityCondition;

      if (!Array.isArray(rules) || rules.length === 0) {
        return true; // If no rules exist, default to visible
      }

      const results = rules.map(rule => {
        const dependsOnField = rule.dependsOn;

        // Check if the field exists in the form data
        if (!this.form.hasOwnProperty(dependsOnField)) {
          return false; // Hide the field if the dependency is missing
        }

        const fieldValue = this.form[dependsOnField];
        const conditionValue = rule.value;

        switch (rule.operator) {
          case "equal":
            return fieldValue === conditionValue;
          case "notEqual":
            return fieldValue !== conditionValue;
          case "greaterThan":
            return fieldValue > conditionValue;
          case "lessThan":
            return fieldValue < conditionValue;
          case "exists":
            return fieldValue !== undefined && fieldValue !== null && fieldValue !== "";
          case "notExists":
            return fieldValue === undefined || fieldValue === null || fieldValue === "";
          default:
            return false;
        }
      });

      return logic === "AND" ? results.every(Boolean) : results.some(Boolean);
    },
    getTextareaHeight(name) {
      if (this.textareaHeights[name]) {
        return this.textareaHeights[name] + 'px'
      }
      return '150px'
    },
    captureManualResize(name) {
      this.$nextTick(() => {
        const textarea = this.getNativeTextarea(name)
        if (!textarea) return
        this.$set(this.textareaHeights, name, textarea.offsetHeight)
        this.$set(this.manualResized, name, true)
      })
    },
    getNativeTextarea(name) {
      const ref = this.$refs[`ta-${name}`]
      if (!ref) return null

      let component = ref

      if (Array.isArray(ref)) {
        component = ref[0]
      }

      if (component.$el) {
        return component.$el.querySelector('textarea')
      }

      if (component.querySelector) {
        return component.querySelector('textarea')
      }

      return null
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileDrop(event) {
      this.dragover = false;
      const files = event.dataTransfer.files;
      if (files.length > 0) {
        this.$refs.fileInput.files = files;
        this.onUploadFile({ target: this.$refs.fileInput });
      }
    },
    async onUploadFile(event) {
            const file = event.target.files[0];
            if (!file) return;
            this.$vs.loading();
            try {
                let formData = new FormData();
                formData.append('file', file);
                const { data } = await TenantRepository.uploadDocumentForAiEngine(formData);
                this.response = data.response

                Object.assign(this.form, data.response);
                this.open = false
                this.open = true
                this.startIndex = 1
            } catch (e) {
                console.log(e);
            }
            this.$vs.loading.close();
            event.target.value = '';
        },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.form_dirty = true
      }
    }
  }
}
</script>

<style scoped>
.create-wizard-pop-up>>>.vs-popup {
  min-width: 80% !important;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
}

th,
td {
  border: 1px solid #ddd;
  padding: 12px;
  text-align: left;
}

th {
  background-color: #f4f4f4;
  font-weight: bold;
}

.delete_button {
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px 24px;
}

.add_button {
  border: none;
  color: white;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px 24px;
}
.create-object-pop-up textarea {
  resize: vertical !important;
}

</style>
